import type { ReactNode } from "react";

import { Stack } from "@mui/material";

import { FLUSHING_SETTINGS_CELL_CLASS_NAME, FLUSHING_SETTINGS_VALUES_CLASS_NAME } from "../lib/transientForm";

type FlushingSettingsRowProps = {
  dayControl: ReactNode;
  label: string;
  nightControl: ReactNode;
};

export const FlushingSettingsRow = ({ dayControl, label, nightControl }: FlushingSettingsRowProps) => {
  return (
    <Stack className=" w-full justify-between">
      <span className="w-[15rem] text-lds-foreground-muted font-ds-body-semibold-sm">{label}</span>
      <div className={FLUSHING_SETTINGS_VALUES_CLASS_NAME}>
        <div className={FLUSHING_SETTINGS_CELL_CLASS_NAME}>{dayControl}</div>
        <div className={FLUSHING_SETTINGS_CELL_CLASS_NAME}>{nightControl}</div>
      </div>
    </Stack>
  );
};
